import useCustomerState from './useCustomerState';

export default function useWishlistData(product) {
  const { customer } = useCustomerState();

  const wishlists = customer?.wishlists;

  const wishlist = wishlists?.length > 0 && wishlists[0];
  const id = wishlists?.length === 0 ? 0 : wishlist?.id;

  const itemId = wishlist?.items_v2?.items?.filter(
    item => item.product.sku === product?.sku
  )[0]?.id;

  return { id, itemId };
}
